/* globals $ App Craft */

class HeaderFormCalculator {
  constructor($elem) {
    this.$postcodeInput = $elem.find("select.postcode-input");
    App.getForms().then(() => {
      App.forms.initSelect(this.$postcodeInput, {
        formatNoMatchesFound: () => {
          return Craft.t("No postcodes found");
        },
      });
      App.forms.initPicker($elem.find(".datepicker"), {
        onReady: () => {
          let id = $elem.find(".dob-input[type=hidden]").attr("id");
          $elem.find(".dob-input[type=hidden]").removeAttr("id");
          $elem.find(".dob-input[type=text]").attr("id", id);
        },
      });
    });
    this.$searchInput = this.$postcodeInput.parent().find(".search-input");
    this.$searchInput.keyup(() => {
      clearTimeout(this.postcodeTimeout);
      this.postcodeTimeout = setTimeout(this.loadPostcodes.bind(this), 500);
    });
  }

  loadPostcodes() {
    this.$postcodeInput.html("");
    let term = this.$searchInput.val();
    if (term.length < 3) {
      this.$postcodeInput.multipleSelect("refresh");
      return;
    }
    $.ajax({
      url: Craft.currentSite.baseUrl,
      method: "post",
      headers: {
        "X-CSRF-Token": Craft.csrfToken,
      },
      data: {
        action: "swissmed/calculator/postcodes",
        countryCode: Craft.currentSite.countryCode,
        term: term,
      },
    }).done((data) => {
      for (var i = data.length - 1; i >= 0; i--) {
        let $option = $('<option value="' + data[i].value + '">' + data[i].label + "</option>");
        this.$postcodeInput.append($option);
      }
      this.$postcodeInput.multipleSelect("refresh");
    });
  }
}

export { HeaderFormCalculator };
